'use client';

import { IntroBox as SharedIntroBox } from '../shared/intro-box';

export function IntroBox() {
  const detailedContent = (
    <>
      <p>
        This section visualizes whether your{' '}
        <strong>supplier is meeting their performance guarantees</strong> as
        outlined in the warranty agreement. These guarantees typically cover key
        indicators like:
      </p>

      <ul className="list-inside list-disc space-y-1">
        <li>
          <strong>SOH (State of Health)</strong> — Indicates long-term capacity
          degradation.
        </li>
        <li>
          <strong>RTE (Round Trip Efficiency)</strong> — Measures energy
          conversion efficiency.
        </li>
        <li>
          <strong>TAG (Total Available Guarantee)</strong> — A custom composite
          or availability KPI.
        </li>
      </ul>

      <p>
        The gauges show the current performance against the{' '}
        <strong>guaranteed minimums</strong>. If a value falls into the yellow
        zone (below guarantee), it reflects{' '}
        <strong>supplier non-compliance</strong>.
      </p>

      <p>
        In these cases, you may be eligible to file claims, request
        compensation, or initiate formal review depending on the terms of the
        agreement.
      </p>
    </>
  );

  return (
    <SharedIntroBox
      title="Performance Guarantees"
      dialogTitle="Supplier Performance Guarantees"
      dialogDescription="Tracking supplier compliance with contractual warranty metrics."
      detailedContent={detailedContent}
    >
      reflect the <em>supplier's obligation</em> to maintain system metrics like
      SOH, RTE, and TAG within agreed thresholds. Falling below these guarantees
      signals <em>supplier non-compliance</em> and may trigger claims.
    </SharedIntroBox>
  );
}
